module.exports = __webpack_public_path__ + "img/step01_b_stand_basic_open_box.530cb67a.png";